// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__94QWU","dashboardLayout":"Dashboard_dashboardLayout__tH6Al"};